import ApiService from "@/core/services/api.service";

// action types
export const UPDATE_PERSONAL_INFO = "updateUserPersonalInfo";
export const INIT_INFO = "initInfo";
export const VERIFY_USER = "verifyUser";
export const UPDATE_CELLPHONE_REQUEST = "updateCellphoneRequest";
export const UPDATE_CELLPHONE_SUBMIT = "updateCellphoneSubmit";
export const UPDATE_PASSWORD_REQUEST = "updatePasswordRequest";
export const UPDATE_PASSWORD_SUBMIT = "updatePasswordSubmit";
export const GET_GATWAYS = "getWays";

// mutation types
export const SET_PERSONAL_INFO = "setPersonalInfo";
export const SET_CELLPHONE = "setCellphone";
export const SET_WALLETS = "setWallets";
export const SET_COMPANY = "setCompany";
export const SET_PROPERTY = "setProperty";
export const SET_OPERATOR = "setOperator";
export const SET_GATEWAYS = "setGateWays";

// profile actions
export const STORE_USER_PROFILE = "storeUserProfile";

// mutation types
export const SET_PROFILE_LOADING = "setProfileLoading";
export const SET_PROFILE_ERROR = "setProfileError";
export const SET_PROFILE = "setProfile";

const state = {
  user_personal_info: {
    id: "",
    photo: "/media/users/blank.png",
    first_name: "",
    last_name: "",
    email: "",
    email_verified_at: "",
    cellphone: "",
    balance: 0,
  },
  wallets: {},
  wallet: 0,
  company: {},
  property: {},
  operator: {},
  profile: null, // ✅ اضافه شد
  gateWays: {},
  loading: false,
  error: null,
};

const getters = {
  currentUserPersonalInfo(state) {
    return state.user_personal_info;
  },
  currentUserWallets(state) {
    return state.wallets;
  },
  currentUserActiveWalletId(state) {
    return state.wallet;
  },
  currentUserCompany(state) {
    return state.company;
  },
  currentUserProperty(state) {
    return state.property;
  },
  currentUserOperator(state) {
    return state.operator;
  },
  gateWays(state) {
    return state.gateWays;
  },
  profileLoading(state) {
    return state.loading;
  },
  profileError(state) {
    return state.error;
  },

  // ✅ اصلاح منطقی
  isProfileCompeleted(state) {
    return state.profile && state.profile.id ? true : false;
  },
};

const actions = {
  [UPDATE_PERSONAL_INFO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("profile", payload)
        .then(({ data }) => {
          context.commit(SET_PERSONAL_INFO, data);
          context.commit(SET_WALLETS, data.wallets);
          context.commit(SET_COMPANY, data.company);
          context.commit(SET_PROPERTY, data.property);
          context.commit(SET_OPERATOR, data.operator);
          if (data.profile) context.commit(SET_PROFILE, data.profile);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [INIT_INFO](context, payload) {
    context.commit(SET_PERSONAL_INFO, payload);
    context.commit(SET_WALLETS, payload.wallets);
    context.commit(SET_COMPANY, payload.company);
    context.commit(SET_PROPERTY, payload.property);
    context.commit(SET_OPERATOR, payload.operator);
  },
  [VERIFY_USER](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("profile")
        .then(({ data }) => {
          context.commit(SET_PERSONAL_INFO, data);
          context.commit(SET_WALLETS, data.wallets);
          context.commit(SET_COMPANY, data.company);
          context.commit(SET_PROPERTY, data.property);
          context.commit(SET_OPERATOR, data.operator);
          if (data.profile) context.commit(SET_PROFILE, data.profile); // ✅ اضافه شد
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  [UPDATE_CELLPHONE_REQUEST](context, payload) {
    return ApiService.patch("profile/cellphone", payload).then(({ data }) => {
      return data;
    });
  },

  [UPDATE_CELLPHONE_SUBMIT](context, payload) {
    return ApiService.post("profile/cellphone/otp", payload).then(
      ({ data }) => {
        context.commit(SET_CELLPHONE, data.cellphone);
        return data;
      }
    );
  },

  [UPDATE_PASSWORD_REQUEST](context, payload) {
    return ApiService.patch("profile/password", payload).then(({ data }) => {
      return data;
    });
  },

  [UPDATE_PASSWORD_SUBMIT](context, payload) {
    return ApiService.post("profile/password/otp", payload).then(({ data }) => {
      return data;
    });
  },
  [GET_GATWAYS](context) {
    ApiService.get("gateways")
      .then(({ data }) => {
        context.commit(SET_GATEWAYS, data);
      })
      .catch((e) => void e);
  },

  [STORE_USER_PROFILE](context, payload) {
    context.commit(SET_PROFILE_LOADING, true);
    context.commit(SET_PROFILE_ERROR, null);

    return new Promise((resolve, reject) => {
      ApiService.post("/profile", payload)
        .then(({ data }) => {
          context.commit(SET_PROFILE, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(
            SET_PROFILE_ERROR,
            response?.data?.message || "خطا در ارسال اطلاعات پروفایل"
          );
          reject(response);
        })
        .finally(() => {
          context.commit(SET_PROFILE_LOADING, false);
        });
    });
  },
};

const mutations = {
  [SET_PERSONAL_INFO](state, payload) {
    state.user_personal_info = {
      id: payload.id,
      photo: "/media/users/blank.png",
      first_name: payload.first_name,
      last_name: payload.last_name,
      email: payload.email,
      email_verified_at: payload.email_verified_at,
      cellphone: payload.cellphone,
      balance: payload.wallets[0] ? payload.wallets[0].balance : "",
    };
  },
  [SET_CELLPHONE](state, cellphone) {
    state.user_personal_info.cellphone = cellphone;
  },
  [SET_WALLETS](state, wallets) {
    state.wallets = wallets;
    if (wallets[0]) {
      state.wallet = wallets[0].id;
    }
  },
  [SET_COMPANY](state, company) {
    if (company) state.company = company;
  },
  [SET_PROPERTY](state, property) {
    if (property) state.property = property;
  },
  [SET_OPERATOR](state, operator) {
    if (operator) state.operator = operator;
  },
  [SET_GATEWAYS](state, data) {
    state.gateWays = data;
  },
  [SET_PROFILE_LOADING](state, status) {
    state.loading = status;
  },
  [SET_PROFILE_ERROR](state, message) {
    state.error = message;
  },
  [SET_PROFILE](state, profile) {
    state.profile = profile;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
